import api from "./api";

export const getAdaptiveSecurityAudits = async () => {
    const res = await api.get("/adaptivesecurityaudit");
    return Array.isArray(res.data) ? res.data : [];
};

export default {
    getAdaptiveSecurityAudits,
};